import { matchmakingUtils } from "@all-good-apps/draft-chess-common"
import { ref } from "firebase/database"
import { database } from "../../../firebase/admin"
import { GameConfig } from "@all-good-apps/draft-chess-common"

export const matchmakingPoolRef = (gameConfig: GameConfig, uid: string) =>
  ref(database, "matchmakingPool/" + matchmakingUtils.getKeyFromGameConfig(gameConfig) + `/${uid}`)
